const Config = {
  RH_URL: process.env.REACT_APP_RH_URL || '',
  INSP_URL: process.env.REACT_APP_INSP_URL || '',
  RECAPCHAKEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  PAYMENT_MODE: process.env.REACT_APP_PAYMENT_MODE || 'sandbox',
};

export default Config;
